import {CONFIG_ERROR, DISPLAY_NAME, APP_CONFIG} from './config/app-config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthProvider';
import ConfigErrorPage from './components/config/ConfigErrorPage';
import RouteInitializationPage from './components/config/RouteInitializationPage';

import { AppConfigProvider } from './config/AppConfigContext';
import {
    applyRuntimeBranding,
    ensureDefaultRoute,
    needsVersionResolution,
} from './config/apply-runtime-branding';

applyRuntimeBranding(APP_CONFIG);

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = (content) => root.render(
    <React.StrictMode>
        {content}
    </React.StrictMode>
);

async function bootstrap() {
    if (CONFIG_ERROR) {
        render(<ConfigErrorPage error={CONFIG_ERROR} />);
        return;
    }

    if (needsVersionResolution(APP_CONFIG)) {
        render(<RouteInitializationPage displayName={DISPLAY_NAME} />);
    }

    try {
        await ensureDefaultRoute(APP_CONFIG);
    } catch (error) {
        render(
            <RouteInitializationPage
                displayName={DISPLAY_NAME}
                error={error}
            />
        );
        return;
    }

    render(
        <AppConfigProvider config={APP_CONFIG}>
            {/* App is a child of the Auth Provider, therefore the
            Auth Provider decides if App is mounted / unmounted */}
            <AuthProvider>
                <App />
            </AuthProvider>
        </AppConfigProvider>
    );

    reportWebVitals();
}

bootstrap().then();
